import { makeStyles } from '@mui/styles';

export default makeStyles(theme => ({
    wrapper: {
        marginTop: 30,
        color: theme.palette.grey[900]
    },
    text: {
        marginTop: 20,
        fontSize: 16
    },
    areasBlock: {
        marginTop: 32,
        border: `2px solid ${theme.palette.grey[200]}`,
        display: 'flex',
        '& .block': {
            padding: 0,
            width: '100%'
        },
        '& .block.equal:first-child': {
            borderRight: `2px solid ${theme.palette.grey[200]}`
        },
        '& .block.equal': {
            width: '50%'
        },
        '& .title': {
            fontSize: 15,
            fontWeight: 700,
            display: 'flex',
            alignItems: 'center',
            padding: '0 45px',
            height: 65,
            gap: 16,
            borderBottom: `2px solid ${theme.palette.grey[200]}`
        },
        '& .points': {
            fontSize: 14,
            padding: '20px 45px 20px 60px'
        },
        '& .points li': {
            listStyle: 'unset'
        }
    },
    accordion: {
        border: `2px solid ${theme.palette.grey[200]}`,
        '& .expansionPanel': {
            backgroundColor: theme.palette.grey[100]
        },
        '& .MuiButtonBase-root': {
            '& p': {
                margin: '0!important',
                fontWeight: 700,
                textTransform: 'capitalize',
                fontSize: 16
            }
        }
    },
    questions: {
        paddingLeft: 22,
        '& li::marker': {
            fontWeight: 700
        }
    }
}));
